import * as React from 'react';

import { useIntl } from 'react-intl';

import { CustomEventNames } from 'state/cdp/constants';

import { RewardsLink as RewardsLinkBase } from './rewards-link.base';

export const RewardsLink = () => {
  const { formatMessage } = useIntl();
  return (
    <RewardsLinkBase
      onClickEventName={CustomEventNames.BUTTON_CLICK_PLK_REWARDS}
      textLabel={formatMessage({ id: 'plkRewards' })}
    />
  );
};
